'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _ = require('../');

var _PlanScorecardCompanyLetter = require('./PlanScorecardCompanyLetter.css');

var _PlanScorecardCompanyLetter2 = _interopRequireDefault(_PlanScorecardCompanyLetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardCompanyLetter = (_dec = (0, _reactCssModules2.default)(_PlanScorecardCompanyLetter2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardCompanyLetter, _Component);

  function PlanScorecardCompanyLetter(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardCompanyLetter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardCompanyLetter.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardCompanyLetter)).call(this, props));

    _this.state = {
      planPath: _this.props.planPath,
      show: _this.props.url.hash === '#letter',
      //
      //
      //
      companiesWithLetter: ['adobe', 'airbnb', 'amazon_com', 'apple', 'booking_holdings', 'broadcom', 'campbell_soup', 'chipotle', 'comcast', 'disney', 'dollar_general', 'etsy', 'fedex', 'google', 'intuit', 'meta', 'microsoft', 'netflix', 'oracle', 'pinterest', 'progressive', 'prologis', 'qualcomm', 'quanta_services', 'regeneron_pharmaceuticals', 'stryker', 'take_two_interactive_software', 'target', 'tesla', 'tjx_companies', 'vertex_pharmaceuticals', 'visa'],
      //
      //
      //
      letterConfig202211: {
        broadcom: {
          companyName: 'Broadcom',
          companyPath: 'broadcom',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Tan',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Hock Tan',
            _react2.default.createElement('br', null),
            'Chief Executive Officer'
          ),
          address: _react2.default.createElement(
            'span',
            null,
            '1320 Ridder Park Dr.',
            _react2.default.createElement('br', null),
            'San Jose, CA',
            _react2.default.createElement('br', null),
            '95131'
          ),
          aspirationalGoal: 'goals to manage our business in a sustainable manner that considers the impact of both our direct operations and supply chain on the planet',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$6.9 billion'
        },
        chipotle: {
          companyName: 'Chipotle Mexican Grill',
          companyPath: 'chipotle',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Niccol',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Brian Niccol',
            _react2.default.createElement('br', null),
            'Chief Executive Officer'
          ),
          address: _react2.default.createElement(
            'span',
            null,
            '610 Newport Center Dr.',
            _react2.default.createElement('br', null),
            'Newport Beach, CA',
            _react2.default.createElement('br', null),
            '92660'
          ),
          aspirationalGoal: 'its commitment to reducing our absolute Scope 1, 2, and 3 greenhouse gas emissions by 50% by 2030, from a 2019 base year',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$159 million'
        },
        fedex: {
          companyName: 'FedEx',
          companyPath: 'fedex',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Subramaniam',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Raj Subramaniam',
            _react2.default.createElement('br', null),
            'Chief Executive Officer'
          ),
          address: _react2.default.createElement(
            'span',
            null,
            '942 S Shady Grove Rd.',
            _react2.default.createElement('br', null),
            'Memphis, TN',
            _react2.default.createElement('br', null),
            '38120'
          ),
          aspirationalGoal: 'its commitment to working toward delivering a more sustainable future including a goal of carbon neutral operations by 2040',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$23.1 billion'
        },
        intuit: {
          companyName: 'Intuit',
          companyPath: 'intuit',
          letterDate: 'November 1, 2022',
          addresseeSurname: 'Mr. Goodarzi',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Sasan Goodarzi',
            _react2.default.createElement('br', null),
            'Chief Executive Officer'
          ),
          address: _react2.default.createElement(
            'span',
            null,
            '2700 Coast Ave',
            _react2.default.createElement('br', null),
            'Mountain View, CA',
            _react2.default.createElement('br', null),
            '94043'
          ),
          aspirationalGoal: 'its goal to help one million small businesses reduce their carbon emissions by 50% by 2030',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$2.3 billion'
        },
        oracle: {
          companyName: 'Oracle',
          companyPath: 'oracle',
          letterDate: 'November 1, 2022',
          addresseeSurname: 'Ms. Catz',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Safra A. Catz',
            _react2.default.createElement('br', null),
            'Chief Executive Officer'
          ),
          address: _react2.default.createElement(
            'span',
            null,
            '2300 Oracle Way',
            _react2.default.createElement('br', null),
            'Austin, TX',
            _react2.default.createElement('br', null),
            '78741'
          ),
          aspirationalGoal: 'its target of 100% renewable energy use by 2025, and the goal to achieve Net Zero emissions by 2050',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$23.6 billion'
        },
        stryker: {
          companyName: 'Stryker',
          companyPath: 'stryker',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Lobo',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Kevin Lobo',
            _react2.default.createElement('br', null),
            'Chief Executive Officer'
          ),
          address: _react2.default.createElement(
            'span',
            null,
            '2825 Airview Blvd',
            _react2.default.createElement('br', null),
            'Portage, MI',
            _react2.default.createElement('br', null),
            '49002'
          ),
          aspirationalGoal: 'its committed goals of making our Scope 1 and Scope 2 greenhouse gas emissions carbon neutral by 2030',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          planAssets: '$4 billion'
        },
        target: {
          companyName: 'Target',
          companyPath: 'target',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Liu',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Don Liu',
            _react2.default.createElement('br', null),
            'Corporate Secretary'
          ),
          address: _react2.default.createElement(
            'span',
            null,
            '1000 Nicollet Mall',
            _react2.default.createElement('br', null),
            'Minneapolis, MN',
            _react2.default.createElement('br', null),
            '55403'
          ),
          aspirationalGoal: 'its 2040 goal to have 100% of our owned brand products be designed for a circular future',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'Fidelity Freedom Blend series',
          planAssets: '$11.6 billion'
        },
        tesla: {
          companyName: 'Tesla',
          companyPath: 'tesla',
          letterDate: 'November 2, 2022',
          addresseeSurname: 'Mr. Musk',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Elon Musk',
            _react2.default.createElement('br', null),
            'Chief Executive Officer'
          ),
          address: _react2.default.createElement(
            'span',
            null,
            '13101 Harold Green Road',
            _react2.default.createElement('br', null),
            'Austin, Texas',
            _react2.default.createElement('br', null),
            '78725'
          ),
          aspirationalGoal: 'its mission to transition to a carbon neutral economy and usher a new sustainable business model for the transportation industry based on zero emissions',
          asOfDate: 'December 31, 2020',
          defaultInvestmentName: 'T. Rowe Price Retirement series',
          planAssets: '$849.5 million'
        }
      },
      //
      //
      //
      letterConfig202302: {
        //
        //
        booking_holdings: {
          companyName: 'Booking Holdings',
          companyPath: 'booking-holdings',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Sonne',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Steve Sonne',
            _react2.default.createElement('br', null),
            'Corporate Secretary'
          ),
          aspirationalGoal: 'its goal to achieve 95% Scope 1 & 2 reduction target by 2030, and achieve net zero by 2040',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'few',
          planAssets: '$389 million'
        },
        //
        //
        dollar_general: {
          companyName: 'Dollar General',
          companyPath: 'dollar-general',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Ms. Connolly',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Christine Connolly',
            _react2.default.createElement('br', null),
            'Vice President, Corporate Secretary and Chief Compliance Officer'
          ),
          aspirationalGoal: 'its goal to committed to an 15% emissions reduction per square foot by 2026 and a 30% reduction per square foot by 2031, each versus a baseline year of 2020',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'T. Rowe Price Retirement series',
          noFewEsgOptions: 'few',
          planAssets: '$682 million'
        },
        //
        //
        etsy: {
          companyName: 'Etsy',
          companyPath: 'etsy',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Silverman',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Josh Silverman',
            _react2.default.createElement('br', null),
            'Chief Executive Officer'
          ),
          aspirationalGoal: 'its goal to achieve a 50% absolute reduction in Scope 1 and 2 GHG emissions and a 52% reduction in Scope 3 GHG emissions per dollar of gross profit from a 2020 base year, by year end 2030',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'few',
          planAssets: '$129 million'
        },
        //
        //
        progressive: {
          companyName: 'Progressive',
          companyPath: 'progressive',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Ms. Griffith',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Tricia Griffith',
            _react2.default.createElement('br', null),
            'President and Chief Executive Officer'
          ),
          aspirationalGoal: 'its goal to become carbon neutral for Scopes 1 and 2 emissions by the end of 2025',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'no',
          planAssets: '$8 billion'
        },
        //
        //
        prologis: {
          companyName: 'Prologis',
          companyPath: 'prologis',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Moghadam',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Hamid Moghadam',
            _react2.default.createElement('br', null),
            'Chairman  and Chief Executive Officer'
          ),
          aspirationalGoal: 'its commitment to achieve net zero emissions across its entire value chain by 2040',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'no',
          planAssets: '$351 million'
        },
        //
        //
        quanta_services: {
          companyName: 'Quanta Services',
          companyPath: 'quanta-services',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Ms. Riddle',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Kim Riddle',
            _react2.default.createElement('br', null),
            'Vice President, Human Resources'
          ),
          aspirationalGoal: 'its achievement of building significant environmental reporting capacity, enabling the collection of CO2 emissions data across 70,000+ vehicle assets and 1,000+ owned and leased properties',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Fidelity Freedom Blend series',
          noFewEsgOptions: 'no',
          planAssets: '$1.4 billion'
        },
        //
        //
        regeneron_pharmaceuticals: {
          companyName: 'Regeneron Pharmaceuticals',
          companyPath: 'regeneron-pharmaceuticals',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. LaRosa',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Joseph LaRosa',
            _react2.default.createElement('br', null),
            'Executive Vice President, General Counsel and Secretary'
          ),
          aspirationalGoal: 'its goal to match 50% of its electricity consumption with electricity from certified renewable energy sources by 2025, and match 100% of electricity consumption by 2035',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Retirement series',
          noFewEsgOptions: 'no',
          planAssets: '$1.7 billion'
        },
        //
        //
        take_two_interactive_software: {
          companyName: 'Take-Two Interactive Software',
          companyPath: 'take-two-interactive-software',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Zelnick',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Strauss Zelnick',
            _react2.default.createElement('br', null),
            'Chairman and Chief Executive Officer'
          ),
          aspirationalGoal: 'its goal to focus on and measure the impact of our ESG activities',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Fidelity Freedom Index series',
          noFewEsgOptions: 'no',
          planAssets: '$416 million'
        },
        //
        //
        tjx_companies: {
          companyName: 'TJX Companies',
          companyPath: 'tjx-companies',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Botte',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Jeff Botte',
            _react2.default.createElement('br', null),
            'Vice President, Investor Relations'
          ),
          aspirationalGoal: 'its goal to achieve net-zero GHG emissions in operations by 2040, and source 100% renewable energy in operations by 2030',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Vanguard Target Date Retirement series',
          noFewEsgOptions: 'no',
          planAssets: '$3.7 billion'
        },
        //
        //
        vertex_pharmaceuticals: {
          companyName: 'Vertex Pharmaceuticals',
          companyPath: 'vertex-pharmaceuticals',
          letterDate: 'February 10, 2023',
          addresseeSurname: 'Mr. Kewalramani',
          addressee: _react2.default.createElement(
            'span',
            null,
            'Reshma Kewalramani',
            _react2.default.createElement('br', null),
            'President and Chief Executive Officer'
          ),
          aspirationalGoal: 'our goal to reduce our global GHG emissions by 20% by 2023 (on an absolute basis)',
          asOfDate: 'December 31, 2021',
          defaultInvestmentName: 'Fidelity Freedom series',
          noFewEsgOptions: 'no',
          planAssets: '$920 million'
        }
      }
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardCompanyLetter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          planPath = _state.planPath,
          show = _state.show;


      if (!this.state.companiesWithLetter.includes(planPath)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'plan-scorecard-company-letter' },
        _react2.default.createElement('div', { styleName: 'anchor', id: 'letter' }),
        _react2.default.createElement(
          'button',
          {
            styleName: 'section-slidedown-button',
            onClick: function onClick(e) {
              _this2.setState({
                show: !show
              });
            }
          },
          _react2.default.createElement(
            'h2',
            { styleName: 'section-slidedown-label' },
            'Our letter to company management'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'section-slidedown-icon' },
            _react2.default.createElement(_.LinkIcon, { faclass: show ? 'fa-angle-up' : 'fa-angle-down' })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          show && planPath === 'adobe' ? _react2.default.createElement(_.AdobeCompanyLetter, null) : null,
          show && planPath === 'airbnb' ? _react2.default.createElement(_.AirbnbCompanyLetter, null) : null,
          show && planPath === 'amazon_com' ? _react2.default.createElement(_.AmazonCompanyLetter, null) : null,
          show && planPath === 'apple' ? _react2.default.createElement(_.AppleCompanyLetter, null) : null,
          show && planPath === 'campbell_soup' ? _react2.default.createElement(_.CampbellSoupCompanyLetter, null) : null,
          show && planPath === 'comcast' ? _react2.default.createElement(_.ComcastCompanyLetter, null) : null,
          show && planPath === 'disney' ? _react2.default.createElement(_.DisneyCompanyLetter, null) : null,
          show && planPath === 'google' ? _react2.default.createElement(_.GoogleCompanyLetter, null) : null,
          show && planPath === 'meta' ? _react2.default.createElement(_.MetaCompanyLetter, null) : null,
          show && planPath === 'microsoft' ? _react2.default.createElement(_.MicrosoftCompanyLetter, null) : null,
          show && planPath === 'netflix' ? _react2.default.createElement(_.NetflixCompanyLetter, null) : null,
          show && planPath === 'pinterest' ? _react2.default.createElement(_.PinterestCompanyLetter, null) : null,
          show && planPath === 'qualcomm' ? _react2.default.createElement(_.QualcommCompanyLetter, null) : null,
          show && planPath === 'visa' ? _react2.default.createElement(_.VisaCompanyLetter, null) : null,
          /* 202211 letters */
          show && (planPath === 'broadcom' || planPath === 'chipotle' || planPath === 'fedex' || planPath === 'intuit' || planPath === 'oracle' || planPath === 'stryker' || planPath === 'target' || planPath === 'tesla') ? _react2.default.createElement(_.CompanyLetter202211, {
            letterConfig: this.state.letterConfig202211[planPath]
          }) : null,
          /* 202302 letters */
          show && (planPath === 'booking_holdings' || planPath === 'dollar_general' || planPath === 'etsy' || planPath === 'progressive' || planPath === 'prologis' || planPath === 'quanta_services' || planPath === 'regeneron_pharmaceuticals' || planPath === 'take_two_interactive_software' || planPath === 'tjx_companies' || planPath === 'vertex_pharmaceuticals') ? _react2.default.createElement(_.CompanyLetter202302, {
            letterConfig: this.state.letterConfig202302[planPath]
          }) : null
        )
      );
    }
  }]);
  return PlanScorecardCompanyLetter;
}(_react.Component), _class2.propTypes = {
  planPath: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardCompanyLetter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardCompanyLetter/PlanScorecardCompanyLetter.js
// module id = 1408
// module chunks = 0